// extracted by mini-css-extract-plugin
export default {"wrapper":"AspectRatio_wrapper__wErux","inner":"AspectRatio_inner__jEr6z"};